/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_List_Filter_InactiveInputs */



/**
* | output |
* | --- |
* | "Inactive 18+ months" |
*
* @param {User_List_Filter_InactiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_filter_inactive = /** @type {((inputs?: User_List_Filter_InactiveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Filter_InactiveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inactif depuis 18 mois ou plus")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inactivo desde hace 18 meses o más")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inativo há 18 meses ou mais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inattivo da 18 mesi o più")
	return /** @type {LocalizedString} */ ("Inactive 18+ months")
});